import { Grid, Tooltip} from "@mui/material";

export function getProduct2skill2exp2rateStruct(){
    return {
        id:{
            name:'id',
            label:'ID',
            value:'',
            error:false,
            errorMessage:'',
            required:false
        },
        
        businessid:{
            name:'businessid',
            label:'Business Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        title:{
            name:'title',
            label:'title',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        skillid:{
            name:'skillid',
            label:'Skill  Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'bodynamiclist'
        },
        skillname:{
            name:'skillname',
            label:'Skill  Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        experiencelevelid:{
            name:'experiencelevelid',
            label:'Experience Level Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'bodynamiclist'
        },
        experiencelevelname:{
            name:'experiencelevelname',
            label:'Experience Level Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        productid:{
            name:'productid',
            label:'Product Id',
            value:'',
            error:false,
            errorMessage:'You must enter Product Id',
            required:true,
            fieldtype:'bodynamiclist'
        },
        productname:{
            name:'productname',
            label:'Product Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        rate:{
            name:'rate',
            label:'Rate',
            value:'',
            error:false,
            errorMessage:'You must enter Rate',
            required:true,
            fieldtype:'double'
        },
        workerid:{
            name:'workerid',
            label:'Worker Id',
            value:'',
            error:false,
            errorMessage:'You must enter Worker Id',
            required:true,
            fieldtype:'bodynamiclist'
        },
        workername:{
            name:'workername',
            label:'Worker Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        typeid:{
            name:'typeid',
            label:'Type Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'number'
        },
      }
}

export function getColumns(payload){
  let actionList = [
        
        { field: 'skillname', headerName: 'Skill  Name', width:150 },
        { field: 'productname', headerName: 'Product Name', width:150 },
        { field: 'rate', headerName: 'Rate', width:150 },
        { field: 'workerid', headerName: 'Worker Id', width:150 },
        { field: 'workername', headerName: 'Worker Name', width:150 },
        { field: 'typeid', headerName: 'Type Id', width:150 },
  ];
  if (payload!==undefined){
    payload.actionList && payload.actionList.map((actionObj)=>{
    actionList.push(
      {
        field: actionObj.title,
        headerName: actionObj.title,
        sortable: false,
        width:60,
        disableClickEventBubbling: false,
        renderCell: (params) => {
          return (
              <Grid item onClick={()=>{actionObj.callBackMethod(params.row.id)}}>
                <Tooltip title={actionObj.title} sx={{cursor: "pointer"}}>
                  {actionObj.icon}
                </Tooltip>
              </Grid>
          );
        }
      })
    })
  }
  return actionList;
}

export function setData(data, formValues, setFormValues){
   
    setFormValues({
      ['id']:{
        ...formValues['id'],
        value:data.id,
      },
       ['businessid']:{
          ...formValues['businessid'],
          value:data.businessid,
        },['title']:{
          ...formValues['title'],
          value:data.title,
        },['skillid']:{
          ...formValues['skillid'],
          value:data.skillid,
        },['skillname']:{
          ...formValues['skillname'],
          value:data.skillname,
        },['experiencelevelid']:{
          ...formValues['experiencelevelid'],
          value:data.experiencelevelid,
        },['experiencelevelname']:{
          ...formValues['experiencelevelname'],
          value:data.experiencelevelname,
        },['productid']:{
          ...formValues['productid'],
          value:data.productid,
        },['productname']:{
          ...formValues['productname'],
          value:data.productname,
        },['rate']:{
          ...formValues['rate'],
          value:data.rate,
        },['workerid']:{
          ...formValues['workerid'],
          value:data.workerid,
        },['workername']:{
          ...formValues['workername'],
          value:data.workername,
        },['typeid']:{
          ...formValues['typeid'],
          value:data.typeid,
        },
      })
}